export enum VisitRefsType {
  SITE_ORG_ID = 'SITE_ORG_ID',
}
